import { useEffect, useRef } from "react";

export default function Stepper({ steps, currentStep }) {
  const prevStep = useRef(currentStep);

  useEffect(() => {
    prevStep.current = currentStep;
  }, [currentStep]);

  const currentStepObj = steps.find(s => s.key === currentStep) || steps[0];

  return (
    <div className="w-full mb-6">
      <div className="flex items-center justify-between w-full">
        {steps.map((stepItem, index) => {
          const isActive = currentStep === stepItem.key;
          const isCompleted = currentStep > stepItem.key;
          const isForward = currentStep > prevStep.current;

          return (
            <div key={stepItem.key} className="flex items-center flex-1 last:flex-none">
              <div className="flex items-center gap-2 relative">
                <div
                  className={`
                    rounded-full flex items-center justify-center font-semibold transition-all duration-300 ease-out z-10 relative
                    w-6 h-6 text-xs sm:w-8 sm:h-8 sm:text-sm
                    ${isCompleted || isActive
                      ? "bg-blue-600 text-white scale-105 shadow-md"
                      : "bg-gray-200 text-gray-500 scale-100"
                    }
                  `}
                >
                  {isCompleted ? "✓" : index + 1}
                </div>

                <span
                  className={`
                    hidden sm:block text-sm font-medium transition-colors duration-300 whitespace-nowrap
                    ${isActive ? "text-blue-600" : "text-gray-500"}
                  `}
                >
                  {stepItem.label}
                </span>
              </div>

              {index < steps.length - 1 && (
                <div className="flex-1 mx-2 h-[2px] bg-gray-200 overflow-hidden min-w-[10px]">
                  <div
                    className={`h-full bg-blue-600 transition-all duration-500 ease-in-out
                      ${isCompleted ? "w-full" : "w-0"}
                      ${isForward ? "origin-left" : "origin-right"}
                    `}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>

      <div className="sm:hidden mt-2 text-center">
        <span className="text-sm font-semibold text-blue-600">
          Passo {steps.indexOf(currentStepObj) + 1}: 
          <span className="text-gray-700 font-medium ml-1">{currentStepObj.label}</span>
        </span>
      </div>
    </div>
  );
}